(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[440],{

/***/ "pN9G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Contact", function() { return Contact; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Contact = function Contact(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 496 480.7"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M484.5 22.9H255.6c-6.3 0-11.4-5.1-11.4-11.4S249.3 0 255.6 0h228.9c6.3 0 11.4 5.1 11.4 11.4s-5 11.5-11.4 11.5zm0 91.6H255.6c-6.3 0-11.4-5.1-11.4-11.4 0-6.3 5.1-11.4 11.4-11.4h228.9c6.3 0 11.4 5.1 11.4 11.4.1 6.2-5 11.4-11.4 11.4zm0 91.5H255.6c-6.3 0-11.4-5.1-11.4-11.4s5.1-11.4 11.4-11.4h228.9c6.3 0 11.4 5.1 11.4 11.4s-5 11.4-11.4 11.4zm0 91.6H11.4c-6.3 0-11.4-5.1-11.4-11.4 0-6.3 5.1-11.4 11.4-11.4h473.1c6.3 0 11.4 5.1 11.4 11.4.1 6.3-5 11.4-11.4 11.4zm0 91.6H11.4C5.1 389.2 0 384 0 377.7s5.1-11.4 11.4-11.4h473.1c6.3 0 11.4 5.1 11.4 11.4.1 6.3-5 11.5-11.4 11.5zm-106.8 91.5H11.4c-6.3 0-11.4-5.1-11.4-11.4 0-6.3 5.1-11.4 11.4-11.4h366.3c6.3 0 11.4 5.1 11.4 11.4.1 6.3-5.1 11.4-11.4 11.4zM125.9 99.2c-27.3 0-49.6-22.3-49.6-49.6S98.6 0 125.9 0s49.6 22.3 49.6 49.6-22.2 49.6-49.6 49.6zm0-76.3c-14.7 0-26.7 12-26.7 26.7s12 26.7 26.7 26.7 26.7-12 26.7-26.7-12-26.7-26.7-26.7zm68.7 198.4c-6.3 0-11.4-5.1-11.4-11.4 0-35.8-25.7-64.9-57.2-64.9s-57.2 29.1-57.2 64.9c0 6.3-5.1 11.4-11.4 11.4S46 216.2 46 209.9c0-48.4 35.9-87.8 80.1-87.8s80.1 39.4 80.1 87.8c-.2 6.3-5.3 11.4-11.6 11.4z"
  }));
};

/***/ })

}]);